exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".separatorNotice{background-color:#512e6f;height:60px}.message{font-size:large;color:#000}", ""]);

// exports
